export default __webpack_public_path__ + "static/media/logo-uceeb.min.3c147efd.svg";